var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 0C3.36875 0 2.75 0.61875 2.75 1.375V20.625C2.75 21.3813 3.36875 22 4.125 22H17.875C18.6313 22 19.25 21.3813 19.25 20.625V5.5L13.75 0H4.125Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.125 5.5H19.25L13.75 0V4.125C13.75 4.88125 14.3687 5.5 15.125 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 9.625L15.125 5.5H19.25V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.875C16.5 18.2531 16.1906 18.5625 15.8125 18.5625H0.6875C0.309375 18.5625 0 18.2531 0 17.875V11C0 10.6219 0.309375 10.3125 0.6875 10.3125H15.8125C16.1906 10.3125 16.5 10.6219 16.5 11V17.875Z",
    fill: "#00843D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.82505 14.0162L5.78136 12.8179C6.06736 12.4439 6.62286 12.9217 6.30936 13.2792C5.98005 13.6697 5.63355 14.0932 5.30355 14.527L6.42486 15.9233C6.72736 16.3358 6.12305 16.7311 5.82605 16.3241L4.81405 15.0268L3.81924 16.3523C3.53874 16.7531 2.91724 16.3028 3.23074 15.9288L4.33555 14.527C3.98905 14.0925 3.65355 13.6697 3.31874 13.2792C2.97292 12.8667 3.61574 12.4439 3.86874 12.8295L4.82505 14.0162Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.10547 13.0259C7.10547 12.8444 7.25947 12.6904 7.45197 12.6904C7.62797 12.6904 7.77647 12.8451 7.77647 13.0259V15.7801H9.27178C9.81009 15.7801 9.82178 16.4999 9.27178 16.4999H7.45266C7.26016 16.4999 7.10616 16.3631 7.10616 16.1651V13.0259H7.10547Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3138 13.5211C10.4403 12.4541 12.0505 12.2623 12.8095 12.8453C13.1835 13.1471 12.7875 13.6256 12.4575 13.3836C12.0505 13.1258 11.1271 13.0048 11.0116 13.5755C10.8631 14.4775 13.2543 13.9611 13.2158 15.4235C13.1773 16.8198 11.1546 16.8521 10.3956 16.2258C10.2135 16.0773 10.2196 15.836 10.3186 15.6868C10.4616 15.5445 10.6205 15.495 10.8081 15.649C11.2585 15.9563 12.419 16.1873 12.5008 15.4063C12.43 14.5936 10.1433 15.0825 10.3138 13.5211Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8125 18.5625H2.75V19.25H15.8125C16.1906 19.25 16.5 18.9406 16.5 18.5625V17.875C16.5 18.2531 16.1906 18.5625 15.8125 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.75ea781786ac24f6f959ba890b0410a4.svg";
export { ForwardRef as ReactComponent };